var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-sider',{attrs:{"menu-items":_vm.menuItems,"defaultSelectedKey":_vm.defaultSelectedKey}},[_c('template',{slot:"content"},[_c('router-view')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }